<template>
    <div class="ant-with-percent">
        <template v-if="rate == 1">
            <img src="/images/rates/ants/bad_full.svg" />
            <v-progress-circular :rotate="90" :size="54" :value="per.low" class="color-blue">
                {{ per.low }}%
            </v-progress-circular>
        </template>
        <template v-if="rate == 2">
            <img src="/images/rates/ants/good_full.svg" />
            <v-progress-circular :rotate="90" :size="54" :width="4" :value="per.middle" class="color-yellow">
                {{ per.middle }}%
            </v-progress-circular>
        </template>
        <template v-if="rate == 3">
            <img src="/images/rates/ants/cool_full.svg" />
            <v-progress-circular :rotate="90" :size="54" :width="4" :value="per.high" class="color-green">
                {{ per.high }}%
            </v-progress-circular>
        </template>
    </div>
</template>

<script>
export default {
    name: 'OrpAnt',
    props: ['percent', 'rate', 'per'],
}
</script>

<style scop>
.ant-with-percent {
    width: 114px;
    display: flex;
    justify-content: space-between;
    margin-right: 40px;
}

.ant-with-percent .color-blue {
    color: #4260a3 !important;
}

.ant-with-percent .color-yellow {
    color: #faaf50 !important;
}

.ant-with-percent .color-green {
    color: #65b337 !important;
}

.ant-with-percent .color-blue .v-progress-circular__info,
.ant-with-percent .color-yellow .v-progress-circular__info,
.ant-with-percent .color-green .v-progress-circular__info {
    color: #1f0303;
    font-size: 14px;
}
</style>